import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'month-click',
    template: `<div class="col-md-12 col-xs-12 no_pad">
    <div class="pull-left from">
      <div class="form-group">
        <label class="text-center">REPORTING PERIOD</label>
        <!--<input type="text" placeholder="Select Month/Year" class="form-control report-period">-->
        <select name="county" (change)="onQrtChange($event.target.value)" required>
          <option value="0">Select Month/Year</option>
          <option value="{{p}}" *ngFor="let p of monthYear" [selected]="currMonthYear == p">Month: {{p}}</option>
        </select>
      </div>
    </div>
    <div class="pull-right">
      <div class="col-md-5 col-xs-12">
        <div class="from">
          <label class="text-center">BEGINNING DATE</label>
          <input type="text" placeholder="dd/mm/yyyy" name="" [(ngModel)]="beginnerQtr" name="beginnerQtr" class="form-control" readonly >
        </div>
      </div>
      <div class="col-md-1 col-xs-12">
        <span style="margin: 50px auto 0 auto;  float: left;">TO</span>
      </div>
      <div class="col-md-5 col-xs-12">
        <div class="TO">
          <label class="text-center">END DATE</label>
          <input type="text" placeholder="dd/mm/yyyy" [(ngModel)]="endQtr" name="endQtr" class="form-control" readonly >
        </div>
      </div>
    </div>
  </div>`
})

export class MonthClickComponent implements OnInit {

    months: any = [];
    years: any = [];
    yy: number;
    mm: number;
    cMonth: string;
    monthYear: any = [];
    currMonthYear: string;
    beginnerQtrM: string;
    public beginnerQtr: string;
    endQtr: string;
    reportDate: any = {};
    monthE: any = [];


    ngOnInit() {
        this.months = [
            { val: '01', name: '01' },
            { val: '02', name: '02' },
            { val: '03', name: '03' },
            { val: '04', name: '04' },
            { val: '05', name: '05' },
            { val: '06', name: '06' },
            { val: '07', name: '07' },
            { val: '08', name: '08' },
            { val: '09', name: '09' },
            { val: '10', name: '10' },
            { val: '11', name: '11' },
            { val: '12', name: '12' }
        ];
        this.monthE = ["31", "28", "31", "30", "31", "30", "31", "31", "30", "31", "30", "31"];
        var today = new Date();
        var endQtrM;
        var ecy: number;
        this.yy = today.getFullYear();
        this.mm = today.getMonth() + 1;
        for (var y = 0; y < this.months.length; y++) {
            if (this.months[y].val <= this.mm) {
                /* if (y != 0) { */
                this.beginnerQtrM = this.months[y].val;
                this.cMonth = this.months[y].name;
                endQtrM = parseInt(this.months[y].val);
                ecy = this.yy;

                /*} else {
                    this.beginnerQtrM = '10';
                    endQtrM = this.months[y].val;
                    this.cMonth = this.months[y].name;
                    ecy = this.yy - 1;
                }*/
            }
        }
        if (this.cMonth == '01') {
            var yy = this.yy - 1;
            var ecy = ecy - 1;
            this.currMonthYear = this.cMonth + ' / ' + yy;
            this.beginnerQtr = this.beginnerQtrM + '/01/' + ecy;
        } else {
            this.currMonthYear = this.cMonth + ' / ' + this.yy;
            this.beginnerQtr = this.beginnerQtrM + '/01/' + ecy;
        }
        this.endQtr = endQtrM + '/' + this.monthE[endQtrM - 1] + '/' + this.yy;
        for (var i = (this.yy - 2); i <= this.yy; i++) {

            this.years.push(i);

        }
        for (var k = (this.yy + 1); k > this.yy; k--) {
            this.years.push(k);
            this.years.push(k + 1);

        }
        for (var j = 0; j < this.years.length; j++) {
            for (let k = 0; k < this.months.length; k++) {
                this.monthYear.push(this.months[k].name + ' / ' + this.years[j]);
            }
        }
    }
    onQrtChange(e) {
        const x = e.split(" / ");
        const cm = x[0];
        const cy = x[1];
        let ecy = x[1];
        let endQtrM;
        for (let y = 0; y < this.months.length; y++) {
            if (this.months[y].name === cm) {
                this.mm = this.months[y].val;
            }
            if (this.months[y].val <= this.mm && this.months[y].val >= this.mm) {

                /* if (y !== 0) { */
                this.beginnerQtrM = this.months[y].val;
                endQtrM = parseInt(this.months[y].val);
                ecy = cy;
                /* } else {
                     this.beginnerQtrM = '10';
                     endQtrM = this.months[y].val;
                     ecy = parseInt(cy) - 1;
                 } */

            }
        }


        if (this.beginnerQtrM == '10') {
            var yy = ecy - 1;
            var cyy = cy - 1;
            this.beginnerQtr = this.beginnerQtrM + '/01/' + yy;
            this.endQtr = endQtrM + '/' + this.monthE[endQtrM - 1] + '/' + cyy;
        } else {
            this.beginnerQtr = this.beginnerQtrM + '/01/' + ecy;
            this.endQtr = endQtrM + '/' + this.monthE[endQtrM - 1] + '/' + cy;
        }
    }

    getDates() {
        this.ngOnInit();

        this.reportDate.beginnerQtr = this.beginnerQtr;
        this.reportDate.endQtr = this.endQtr;
        return this.reportDate;
    }

    getDatesChange(e) {
        this.onQrtChange(e);

        this.reportDate.beginnerQtr = this.beginnerQtr;
        this.reportDate.endQtr = this.endQtr;
        return this.reportDate;
    }


}



// WEBPACK FOOTER //
// ./src/app/monthpicker/MonthClick.ts